function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useMemo, useRef, useState, useCallback, useEffect } from 'react';
import { formatI18n } from '../../I18n/I18n/I18n';
import uuid from '../../utils/uuid';
import { injectIntl } from 'react-intl';
import Tip from '../Tips/Tips';
var TYPE = 'tooltip';
function useValidation(ref) {
  useEffect(function () {
    var el = ref.current;
    if (el) {
      if (!(el.hasAttribute('aria-labelledby') || el.hasAttribute('aria-describedby'))) {
        throw new Error('Tooltip requires adding either `aria-labelledby` or' + ' `aria-describedby` to the attaching component. Use labelledby' + ' or describedby props from render function' + ' (e.g. `<Component ref={ref} aria-labelledby={labelledby} />`).' + ' See https://www.w3.org/TR/wai-aria/#aria-labelledby' + ' for more information on which to use.');
      }
    } else {
      throw new Error('A Tooltip requires adding a ref to the component it is attached to');
    }
  }, [ref]);
}
function Tooltip(_ref) {
  var i18n = _ref.i18n,
    _ref$i18nKey = _ref.i18nKey,
    i18nKey = _ref$i18nKey === void 0 ? '' : _ref$i18nKey,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'bottom' : _ref$direction,
    _ref$neverShow = _ref.neverShow,
    neverShow = _ref$neverShow === void 0 ? false : _ref$neverShow,
    children = _ref.children,
    intl = _ref.intl,
    Component = _ref.Component,
    className = _ref.className;
  var ref = useRef(null);
  var tooltipRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShowing = _useState2[1];
  var _useState3 = useState("".concat(TYPE, "-").concat(uuid())),
    _useState4 = _slicedToArray(_useState3, 1),
    id = _useState4[0];
  var ariaId = show ? id : '';
  var i18nProp = typeof i18nKey !== 'undefined' && i18nKey !== '' ? i18nKey : typeof i18n !== 'undefined' ? i18n : '';
  var hideTooltip = useCallback(function (e) {
    var currentTarget = e.currentTarget;
    var relatedTarget = e.relatedTarget;
    var tip = tooltipRef.current;
    if (
    // is it mouseleave from tip?
    !(relatedTarget instanceof Node) ||
    // has focus moved off the trigger?
    ref.current !== document.activeElement && !currentTarget.contains(relatedTarget) && tip &&
    // is the mouse in the tooltip?
    !tip.contains(relatedTarget)) {
      setShowing(false);
    }
  }, []);
  var showTooltip = useCallback(function () {
    setShowing(true);
  }, []);

  // see: https://github.com/facebook/react/issues/13029

  useValidation(ref);

  // add aria-label to element so it shows up in Rotor and other places
  useEffect(function () {
    var el = ref.current;
    if (el && el.hasAttribute('aria-labelledby')) {
      var label = formatI18n(intl, i18nProp);
      el.setAttribute('aria-label', label);
    }
  }, [i18nProp, intl]);
  var childrenProps = useMemo(function () {
    return {
      ref: ref,
      labelledby: ariaId,
      describedby: ariaId,
      events: {
        onMouseOver: showTooltip,
        onFocus: showTooltip,
        onMouseOut: hideTooltip,
        onBlur: hideTooltip
      }
    };
  }, [ariaId, showTooltip, hideTooltip]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(childrenProps), /*#__PURE__*/React.createElement(Tip, {
    ref: tooltipRef,
    id: id,
    triggerRef: ref,
    show: neverShow ? false : show,
    type: TYPE,
    direction: direction,
    onMouseOut: hideTooltip,
    Component: Component,
    className: className
  }, i18nProp));
}
export default injectIntl(Tooltip);